import { motion } from "framer-motion";
import { Star, ArrowUpRight, MessageSquarePlus } from "lucide-react";

const GOOGLE_URL = "https://g.page/r/CaPPEuliEVu8EAE/review";

export default function Avis() {
  return (
    <section id="avis" data-testid="avis-section" className="py-28 lg:py-40 border-t border-white/10 bg-[#0C0C0E]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-xs tracking-[0.3em] uppercase text-jaune font-bold mb-4">Avis clients</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl leading-tight">
            Ils nous confient<br />leur toit
          </h2>
          <p className="mt-6 text-base text-zinc-400 leading-relaxed font-light max-w-md">
            Depuis plus de 20 ans, nos clients normands nous recommandent pour la
            qualité de notre travail et notre sérieux sur chantier. Leurs avis
            sont publics et vérifiables sur Google.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={GOOGLE_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="avis-google-link"
              className="group flex items-center justify-center gap-2 bg-white text-black px-7 py-4 text-xs tracking-[0.15em] uppercase font-bold hover:bg-jaune transition-colors duration-300"
            >
              Voir nos avis Google
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={GOOGLE_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="avis-leave-review-link"
              className="flex items-center justify-center gap-2 border border-white/30 px-7 py-4 text-xs tracking-[0.15em] uppercase font-bold hover:border-jaune hover:text-jaune transition-colors duration-300"
            >
              <MessageSquarePlus className="w-4 h-4" />
              Laisser un avis
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="border border-white/10 bg-[#121214] p-10 lg:p-14 text-center"
          data-testid="avis-rating-card"
        >
          <p className="font-display font-black text-7xl lg:text-8xl tracking-tighter" data-testid="avis-rating-value">
            4,9<span className="text-jaune">/5</span>
          </p>
          <div className="mt-6 flex justify-center gap-2" aria-label="Note de 4,9 sur 5">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} className="w-6 h-6 fill-jaune text-jaune" />
            ))}
          </div>
          <p className="mt-6 text-xs tracking-[0.25em] uppercase text-zinc-500 font-bold">
            Note Google — Ent. Goujon Vallée
          </p>
          <p className="mt-2 text-xs text-zinc-600">Couverture · Charpente · Isolation — Bosgouet (27)</p>
        </motion.div>
      </div>
    </section>
  );
}
